import { loaderActionsType } from '../actions';

const initialState = { pending: false };

export function loading(state = initialState, action) {
  switch (action.type) {
    case loaderActionsType.PENDING:
      return {
        pending: true
      };
    case loaderActionsType.END:
      return {
        pending: false
      };
    default:
      return state
  }
}
